import "dotenv/config";
export const POSTHOG_API_KEY = process.env.POSTHOG_API_KEY || "";
export const POSTHOG_HOST_API = process.env.POSTHOG_HOST_API || "https://app.posthog.com";
export const POSTHOG_ANNOUNCEMENT_SUFFIX = process.env.POSTHOG_ANNOUNCEMENT_SUFFIX || "announcement";
